import React from "react";

import { testIdProps } from "../../../../utils/testIdProps";
import SharedStyles from "../Shared/sharedStyles.module.scss";
import Styles from "./servicesPopup.module.scss";

interface TrialPopupHeaderProps {
  title: string;
  onClose: () => void;
  closeButtonId: string;
}

function TrialPopupHeader({
  title,
  onClose,
  closeButtonId,
}: TrialPopupHeaderProps) {
  return (
    <div className={Styles.header}>
      <div>
        <div className={`${SharedStyles.trialText} pl-2`}>Running Trial on</div>
        <div className={`${SharedStyles.headingText} pl-2`}>{title}</div>
      </div>
      <button
        type="button"
        className={Styles.cancelButton}
        onClick={onClose}
        aria-label="Close"
        {...testIdProps(closeButtonId)}
      >
        X
      </button>
    </div>
  );
}

export default TrialPopupHeader;
